import { Input, styled, SxProps, TextField } from '@mui/material'
import styles from './index.module.scss'
import pxToRem from '../../helpers/pxToRem'

export const UserRegTextField = styled(TextField)({
    '& .MuiOutlinedInput-root': {
        '&:hover fieldset': {
            borderColor: styles.primaryYellow500,
            color: styles.primaryYellow500,
        },
        '&.Mui-focused fieldset': {
            borderColor: styles.primaryYellow500,
            color: styles.primaryYellow500,
        },
    },
    '& .MuiInputBase-root': {
        '&::after': {
            borderBottom: `2px solid ${styles.primaryYellow500}`,
        },
        '&::before': {
            // borderBottom: `1px solid ${styles.neutrals400}`
        },
        '&:hover:not(.Mui-disabled, .Mui-error):before': {
            borderBottom: `1px solid ${styles.primaryYellow500}`,
        },
        '&.Mui-focused:after': {
            borderBottom: `${pxToRem(2)} solid ${styles.primaryYellow500}`,
        },
    },
    '&:hover .MuiInputLabel-root': {
        // color: styles.primaryYellow500,
        // color: styles.primaryYellow500,
    },
    '& .MuiInputLabel-root.Mui-focused': {
        color: styles.primaryYellow500,
        // color:'#00000099'
    },
})
export const UserRegSx: SxProps = {
    // height: '100%',
    // height: 56,
    // borderColor: ''
    '& .MuiOutlinedInput-root,.MuiPickersInputBase-root': {
        '&:not(.Mui-disabled)': {
            '&:hover fieldset': {
                borderColor: styles.primaryYellow500,
                color: styles.primaryYellow500,
            },
            '&.Mui-focused fieldset': {
                borderColor: `${styles.primaryYellow500} !important`,
                color: styles.primaryYellow500,
            },
        },
    },
    '& .MuiInputBase-root,.MuiPickersInputBase-root': {
        // height: '100%',
        '&:not(.Mui-disabled)': {
            '&::after': {
                borderBottom: `2px solid ${styles.primaryYellow500}`,
            },
            '&::before': {
                // borderBottom: `1px solid ${styles.neutrals400}`
            },
            '&:hover:not(.Mui-error):before': {
                borderBottom: `1px solid ${styles.primaryYellow500}`,
            },
            '&.Mui-focused:after': {
                borderBottom: `${pxToRem(2)} solid ${styles.primaryYellow500}`,
            },
        },
    },
    '&:hover .MuiInputLabel-root': {
        // color: styles.primaryYellow500,
        // color: styles.primaryYellow500,
    },
    '& .MuiInputLabel-root.Mui-focused': {
        color: styles.primaryYellow500,
        // color:'#00000099'
    },
    '& .MuiFormLabel-root.Mui-focused': {
        color: styles.shades100,
    },

    // '& .MuiFormControl-root': {
    // }
}

export const OptionalTextField = styled(TextField)({
    backgroundColor: styles.neutrals100,
    color: styles.neutrals500,
    padding: pxToRem(16),
    fontSize: pxToRem(14),
    lineHeight: pxToRem(20) /* 142.857% */,
    letterSpacing: pxToRem(-0.28),
})

export const ProfileTextField = styled(TextField)({
    color: styles.neutrals500,

    backgroundColor: styles.shades0,

    borderRadius: pxToRem(16),
    border: `1px solid #B0B0B0`,

    padding: pxToRem(16),
    fontSize: pxToRem(14),
    lineHeight: pxToRem(20) /* 142.857% */,
    letterSpacing: pxToRem(-0.28),
})

export const SchoolRegSx = {
    '& .MuiOutlinedInput-root,.MuiPickersOutlinedInput-root': {
        '&:not(.Mui-disabled)': {
            '&:hover fieldset': {
                borderColor: styles.primaryPurple400,
                color: styles.primaryPurple400,
            },
            '&.Mui-focused fieldset': {
                borderColor: `${styles.primaryPurple400} !important`,
                color: styles.primaryPurple400,
            },
            fieldset: {
                borderColor: styles.neutrals100,
            },
        },
    },
    // '& .MuiInputBase-root,.MuiPickersInputBase-root': {
    //     '&::after': {
    //         border: `2px solid ${styles.primaryPurple400}`,
    //     },
    //     '&::before': {
    //         // borderBottom: `1px solid ${styles.neutrals400}`
    //     },
    //     '&:hover:not(.Mui-disabled, .Mui-error):before': {
    //         'fieldset': {
    //             border: `1px solid ${styles.primaryPurple400}`,
    //         }
    //     },
    //     '&.Mui-focused:after': {
    //         'fieldset': {
    //             border: `${pxToRem(2)} solid ${styles.primaryPurple400}`,
    //         }
    //     },
    // },
    '&:hover label': {
        // color: styles.primaryYellow500,
        // color: styles.primaryYellow500,
    },
    '& label.Mui-focused': {
        color: styles.primaryPurple400,
        // color:'#00000099'
    },
}

export const SchoolRegTextField = styled(TextField)(SchoolRegSx)

export const LoginSx = {
    // Label Styling
    '& label': {
        color: styles.neutrals500,
        path: {
            transition: 'fill 200ms',
            fill: styles.neutrals500,
        },
    },
    '&:hover label': {
        color: styles.neutrals500,
        path: {
            fill: styles.neutrals500,
        },
    },
    '&:hover label.Mui-error': {
        color: styles.error_red,
        path: {
            fill: styles.error_red,
        },
    },
    '& label.Mui-focused': {
        textAlign: 'center',
        color: styles.shades100,
        path: {
            fill: styles.shades100,
        },
        '&.Mui-error': {
            color: styles.error_red,
            path: {
                fill: styles.error_red,
            },
        },
        // color:'#00000099'
    },
    '& label.Mui-error': {
        path: {
            fill: styles.error_red,
        },
    },
    '& .MuiSvgIcon-root': {
        fill: styles.neutrals500,
    },

    '.MuiOutlinedInput-notchedOutline > legend > span': {
        paddingRight: 0,
        marginRight: '0.5ch',
    },

    // Input Styling
    '& .MuiOutlinedInput-root': {
        '&:hover fieldset': {
            borderColor: styles.primaryYellow500,
        },
        '&.Mui-focused fieldset': {
            borderColor: styles.primaryYellow500,
        },
        '&.Mui-error fieldset': {
            borderColor: styles.error_red,
        },
    },

    // '&:hover .MuiSvgIcon-root': {
    //     fill: styles.neutrals500,
    // }
}
export const LoginTextField = styled(TextField)(LoginSx)

export const LoginIconSx = {
    // Label Styling
    '& label': {
        color: styles.neutrals500,
        path: {
            transition: 'fill 200ms',
            fill: styles.neutrals500,
        },
    },
    '&:hover label': {
        color: styles.neutrals500,
        path: {
            fill: styles.neutrals500,
        },
    },
    '&:hover label.Mui-error': {
        color: styles.error_red,
        path: {
            fill: styles.error_red,
        },
    },
    '& label.Mui-focused': {
        textAlign: 'center',
        color: styles.shades100,
        path: {
            fill: styles.shades100,
        },
        '&.Mui-error': {
            color: styles.error_red,
            path: {
                fill: styles.error_red,
            },
        },
        // color:'#00000099'
    },
    '& label.Mui-error': {
        path: {
            fill: styles.error_red,
        },
    },
    '& .MuiSvgIcon-root': {
        fill: styles.neutrals500,
    },

    '.MuiOutlinedInput-notchedOutline > legend > span': {
        // paddingRight: 0,
        marginRight: '-1.3ch',
    },

    // Input Styling
    '& .MuiOutlinedInput-root': {
        '&:hover fieldset': {
            borderColor: styles.primaryYellow500,
        },
        '&.Mui-focused fieldset': {
            borderColor: styles.primaryYellow500,
        },
        '&.Mui-error fieldset': {
            borderColor: styles.error_red,
        },
    },

    // '&:hover .MuiSvgIcon-root': {
    //     fill: styles.neutrals500,
    // }
}
export const LoginIconTextField = styled(TextField)(LoginIconSx)

export const SchoolMainInput = styled(Input)({
    '& .MuiInputBase-root': {
        '&::after': {
            borderBottom: `2px solid ${styles.primaryBlue500}`,
        },
        '&::before': {
            // borderBottom: `1px solid ${styles.neutrals400}`
        },
        '&:hover:not(.Mui-disabled, .Mui-error):before': {
            borderBottom: `1px solid ${styles.primaryBlue500}`,
        },
        '&.Mui-focused:after': {
            borderBottom: `${pxToRem(2)} solid ${styles.primaryBlue500}`,
        },
    },
    '&:hover label': {
        // color: styles.primaryYellow500,
        // color: styles.primaryYellow500,
    },
    '& label.Mui-focused': {
        color: styles.primaryBlue500,
        // color:'#00000099'
    },
})
